export default {
	openInApp: 'open',
	loginFromBrowser: 'login',
	oauth: 'code',
};
